<template>
  <div class="dashboard-block">
    <form>
      <h2>{{this.title}}</h2>

      <div class="panel panel-grey">
        <div class="panel-body">
          <div class="form-horizontal">

            <div>
              <div class="row">
                <div class="col-xs-12">
                  <div class="col-xs-1">Name</div>
                  <div class="col-xs-7">Label</div>
                  <div class="col-xs-2">Type</div>
                  <div class="col-xs-1">Enabled</div>
                  <div class="col-xs-1" v-if="attribute === 'user_custom_fields'">Public</div>
                </div>
              </div>
            </div>
            <div v-for="(field, index) in customFields" :key="index">
              <div class="row">
                <div class="form-group col-xs-12">
                  <label class="control-label col-xs-1 text-capitalize" >{{field.fieldName}}</label>
                  <div :class="$hasErrorClass($v.customFields.$each[index].fieldLabel, 'col-xs-7')">
                    <input type="text" placeholder="Field Name" class="form-control" v-model="$v.customFields.$each[index].fieldLabel.$model" :name="field.fieldName" :id="field.fieldName"/>
                    <vuelidate-help :field="$v.customFields.$each[index].fieldLabel" :label="field.fieldName" />
                  </div>
                  <div class="col-xs-2" v-if="field.dataType && field.newlyAdded">
                    <select v-model="field.dataType" :name="'field_type'+field.fieldName" :id="'field_type'+field.fieldName" class="form-control" title="Data type">
                      <option v-bind:key="index" v-for="(option, index) in supportedTypes" :value="index">{{ option }}</option>
                    </select>
                  </div>
                  <div class="col-xs-2" v-else-if="field.dataType" title="Data type">
                    <label class="control-label col-xs-1 col-lg-1 text-capitalize">{{field.dataType}}</label>
                  </div>
                  <div class="col-xs-2" v-else title="Data type">
                    <label class="control-label col-xs-1 col-lg-1 text-capitalize" >Text</label>
                  </div>
                  <div class="col-xs-1 spacer-y-2" title="Enable / Disable">
                    <toggle-button
                      class="pull-right"
                      v-model="field.active"
                      :labels="{ checked: 'Yes', unchecked: 'No' }"
                      :color="{ checked: brandPrimary, unchecked: '#b7b7b7' }"/>
                  </div>
                  <div class="col-xs-1 spacer-y-2" title="Public / Private" v-if="attribute === 'user_custom_fields'">
                    <toggle-button
                      class="pull-right"
                      v-model="field.public"
                      :labels="{ checked: 'Yes', unchecked: 'No' }"
                      :color="{ checked: brandPrimary, unchecked: '#b7b7b7' }"/>
                  </div>
                </div>
              </div>
              <div class="row" v-if="field.dataType === 'dropdown'">
                <div class="form-group col-xs-12 col-lg-12">
                  <div class="col-xs-offset-1 col-lg-offset-1 col-xs-7 col-lg-7">
                    <input type="text" v-model="field.listOptions" :name="'listOptions' + field.fieldName" placeholder="Comma separated list" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <a class="cursor-pointer"  @click="addNewCustomField" >Add new <i class="fa fa-plus"></i></a>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <ladda-button class="btn btn-sm btn-primary" type="submit" :click="handleSaveCustomFieldCallback" >Save Changes</ladda-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { stateMapper } from 'mixins/settings'
import { notify } from 'utils'
import { each, forIn } from 'lodash'
import { required } from 'vuelidate/lib/validators'
import VuelidateHelp from '../misc/VuelidateHelp'

export default {
  props: ['customFieldValues', 'title', 'endpoint', 'attribute'],
  mixins: [stateMapper],

  components: {
    VuelidateHelp
  },

  validations: {
    customFields: {
      $each: {
        fieldLabel: { required }
      }
    }
  },

  data () {
    return {
      customFields: []
    }
  },

  mounted () {
    if (this.customFieldValues) {
      this.refreshCustomFields()
    }
  },
  computed: {
    ...mapState('settings', ['settings']),
    supportedTypes () {
      return {
        text: 'Text',
        date: 'Date',
        file: 'File',
        dropdown: 'Dropdown',
        url: 'URL'
      }
    }
  },
  methods: {
    ...mapActions('settings', ['updateCustomField']),

    refreshCustomFields () {
      const customFieldObj = JSON.parse(this.customFieldValues)
      this.customFields = Object.keys(customFieldObj).map((k) => {
        return {
          fieldLabel: customFieldObj[k]['fieldLabel'],
          fieldName: k,
          active: customFieldObj[k]['active'],
          dataType: customFieldObj[k]['dataType'],
          listOptions: customFieldObj[k]['listOptions'],
          public: customFieldObj[k]['public']
        }
      })
    },
    handleSaveCustomFieldCallback () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error('Some fields are invalid. Please check and try again.')
        return Promise.resolve()
      }
      return this.updateCustomField(
        {
          data: {'custom_fields': this.customFields},
          endpoint: this.endpoint,
          attribute: this.attribute
        }
      ).then(() => {
        notify.success('Successfully saved custom fields settings.')
        this.refreshCustomFields()
        this.errors.clear()
      })
        .catch((errors) => {
          if (errors.response && errors.response.status === 422) {
            forIn(errors.response.data.errors, (errors, key) => {
              each(errors, error => notify.error(error))
            })
          } else {
            notify.error('Sorry something has gone wrong, please try again.')
            throw errors
          }
        })
    },
    addNewCustomField () {
      const nextCustomFieldIndex = Object.keys(this.customFields).length + 1
      this.customFields = [...this.customFields, {
        fieldLabel: '',
        fieldName: 'custom' + nextCustomFieldIndex,
        active: true,
        dataType: 'text',
        listOptions: '',
        newlyAdded: true,
        public: false
      }]
    }
  }
}
</script>
